var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAquarius(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 11.026 48.112.64 46.65.105 34.662 9.368 32.712.641 31.544.105 19.311 9.612 17.313.642l-1.51-.537L2.4 10.49l1.12 1.462 12.281-9.458 1.998 8.922 1.511.536 11.94-9.263 1.998 8.727 1.12.536L46.65 2.494l1.998 8.922 1.852-.39zM48.6 26.969l-2.34-10.434L44.75 16 32.81 25.31l-1.95-8.776L29.692 16l-12.232 9.507-2.047-8.97-1.462-.537L.5 26.433l1.17 1.462 12.232-9.507 2.046 8.97 1.462.537L29.4 18.632l1.949 8.727 1.17.536 12.231-9.507 2.047 8.97 1.803-.39z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAquarius);
export default __webpack_public_path__ + "static/media/aquarius.54ab4cbb712447c299e6c4f90cd8f4c1.svg";
export { ForwardRef as ReactComponent };